import { FormikErrors } from 'formik';
import { TFunction } from 'react-i18next';
import { IOrganisation } from '~/Models/DTO/Organisation.model';

export const settingsDetailVerification = (data: IOrganisation, t: TFunction) => {
  const errors = {} as FormikErrors<IOrganisation>;
  const MISSING_MESSAGE = t('app.form.validation.required');
  if (!data.name) {
    errors.name = MISSING_MESSAGE;
  }
  if (!data.email) {
    errors.email = MISSING_MESSAGE;
  }

  return errors;
};
